export const PING_SUCCESS = 'ping/PING_SUCCESS';
